import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../apis/api";
import { loadingEnd, loadingStart } from "../setLoading/setLoading";
export const getProductStep = createAsyncThunk(
  "getproductSteps/get",
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(loadingStart());
    const backend = new API();
    try {
      const response = await backend.fetch(API.productSteps(data), {
        method: "GET",
      });

      dispatch(loadingEnd());
      // You may want to return some data here if needed
      return response;
    } catch (error) {
      dispatch(loadingEnd());
      console.error("Error creating user:", error);
      // You can handle the error here or throw it again if needed
      return rejectWithValue(error);
    }
  }
);
